import { render, staticRenderFns } from "./registeredContent.vue?vue&type=template&id=125a3c63&scoped=true&"
import script from "./registeredContent.vue?vue&type=script&lang=js&"
export * from "./registeredContent.vue?vue&type=script&lang=js&"
import style0 from "./registeredContent.vue?vue&type=style&index=0&id=125a3c63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a3c63",
  null
  
)

export default component.exports